import { render, staticRenderFns } from "./AppLabeledData.vue?vue&type=template&id=233a570f&scoped=true&"
import script from "./AppLabeledData.vue?vue&type=script&lang=js&"
export * from "./AppLabeledData.vue?vue&type=script&lang=js&"
import style0 from "./AppLabeledData.vue?vue&type=style&index=0&id=233a570f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233a570f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
